import { TranslationLanguage } from "@redotech/cockroachdb-codegen/tables/returns/translation-language";
import { FLOW_ELEMENT_TRANSLATABLE_FIELDS } from "@redotech/redo-return-core-common/return-flow/flow-element-translation";
import * as z from "zod";

export const TRANSLATION_SOURCES = ["ai", "merchant"] as const;

const KeySchema = z.object({
  elementId: z.string().max(100),
  field: z.enum(FLOW_ELEMENT_TRANSLATABLE_FIELDS),
  language: z.enum(TranslationLanguage),
});

/**
 * Upserts and deletes a team's flow element translations. A cleared editor
 * value arrives as a delete, so the portal falls back to Redo's default
 * translation (or the English literal) instead of rendering an empty string.
 * Bounded: one editor panel saves a few fields across at most 13 languages.
 */
export const setFlowElementTranslations = {
  name: "setFlowElementTranslations" as const,
  input: z.object({
    writes: z
      .array(
        KeySchema.extend({
          text: z.string().min(1).max(5000),
          source: z.enum(TRANSLATION_SOURCES),
          flowType: z.string().max(100).optional(),
        }),
      )
      .max(200),
    deletes: z.array(KeySchema).max(200),
  }),
  output: z.object({}),
};

type SetFlowElementTranslationsInput = z.infer<
  typeof setFlowElementTranslations.input
>;

export type FlowElementTranslationWrite =
  SetFlowElementTranslationsInput["writes"][number];
export type FlowElementTranslationDelete =
  SetFlowElementTranslationsInput["deletes"][number];
export type FlowElementTranslationSource =
  FlowElementTranslationWrite["source"];
